<template>
  <div class="page">
    <Menu :curName="'全部课程'"/>
    <section class="cContent">
      <!-- <ul class="tab">
        <li @click="oneCateClick(-1)" :class="oneCateSelectedId == -1?'active':''">
            全部
        </li>
      <li
          @click="oneCateClick(item.id)"
          v-for="item in courseCateTree"
          :key="'oneCate'+item.id"
          :class="oneCateSelectedId == item.id ?'active':''"
        >{{item.name}}</li>
      </ul>
      <ul class="tab" style="margin-top:20px;">
        <li @click="twoCateClick(-1)" :class="twoCateSelectedId == -1?'active':''">
            全部
        </li>
        <li
          @click="twoCateClick(item.id)"
          v-for="item in twoCate"
          :key="'twoCate'+item.id"
          :class="twoCateSelectedId == item.id ?'active':''"
        >{{item.name}}</li>
      </ul> -->
      <div class="list">
        <CourseList :list="courseObj.data" :keyStr="'courseList'" />
      </div>
      <pager
        :total-page="Math.ceil(courseObj.total / pageSize)"
        :init-page="courseObj.current_page"
        @go-page="goPage"
      ></pager>
    </section>
  </div>
</template>

<script>
import Menu from "@/components/Menu.vue";
import pager from "@/components/pager.vue";
import CourseList from "@/components/CourseList.vue";
import {
  courseListByCateId,
  courseCateTree
} from "@/api/course.js";

export default {
  data() {
    return {
      oneCateSelectedId: -1, //一级分类选中id
      twoCateSelectedId: -1, //二级分类选中id
      page: 1,
      pageSize: 10,
      currentCateId: 0, //当前分类id，这个id是二级的
      courseObj: {},
      courseCateTree: [], //课程分类树
      twoCate:[],//当前二级分类
    };
  },
  mounted() {
    this.getCateTree();
     //是否有从其他页面传递分类id
    if (this.$route.params.id) {
      if (this.$route.params.id && this.$route.params.id.indexOf(",")) {
        var arr = this.$route.params.id.split(","); //第1个参数是父分类,第2个参数是子分类
        this.currentCateId = arr[1];
        this.oneCateClick(arr[0]);
        this.twoCateSelectedId = arr[1];
       
      }
    }
    this.CourseListByCateIdFun();
  },
  methods: {
     //获取分类
    getCateTree: function() {
      courseCateTree().then(resp => {
        if (resp != -1) {
          this.courseCateTree = resp;
        }
      });
    }, 
    CourseListByCateIdFun: function() {
      courseListByCateId(this.currentCateId, this.page).then(resp => {
        if (resp != -1) {
          this.courseObj = resp;
        }
      });
    },
    oneCateClick: function(index) {
      this.oneCateSelectedId = index;
      this.courseObj = {}; 
      if(index>-1){
         for(let a of this.courseCateTree){
          if(a.id == index){
            this.twoCate = a.child;
            //请求列表数据
            this.currentCateId = a.id;
            this.CourseListByCateIdFun();
            return;
          } 
        }
      }else{
          this.currentCateId = -1;
          this.twoCate = [];
          this.CourseListByCateIdFun();
      }
    },
    //二级分类点击事件
    twoCateClick: function(id) {
      this.twoCateSelectedId = id;
      if(id ==-1){      
        this.currentCateId = this.oneCateSelectedId; //请求父分类id
      }else{
        this.currentCateId =  id;
      }
      this.CourseListByCateIdFun();
    },
    goPage: function(e) {
      this.page = e.page;
      this.CourseListByCateIdFun();
    }
  },
  components: {
    Menu,
    pager,
    CourseList
  }
};
</script>


<style lang="scss" scoped>
.cContent {
  width: 1200px;
  margin: 0 auto;padding-bottom:30px;
  .tab {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin: 0;
    li {
      padding: 5px 12px;
      color: #8a8888;
      border-radius: 15px;
      margin-right: 15px;
      font-size: 1.4em;
      cursor: pointer;
    }
    .active {
      background: #3283fd;
      color: white;
    }
  }
  .list{margin-top: 20px;}
}
</style>